/**
 * Guess language and redirect the user to that page
 *
 * Maybe this should be a guard...
 */
import { Component, ChangeDetectionStrategy } from '@angular/core';



@Component({
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class VariationRootPageComponent {
  lang = '';
}
